function debounce(func, wait) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, arguments), wait);
  };
}
const cartDrawer = {
  $el: $("#shopify-section-main-cart-drawer"),
  $form: $("#CartDrawer-Form"),
  open() {
    $("body").addClass("no-scroll");
    this.updateCart();
    cartDrawer.$el.fadeIn(300, () => {
      cartDrawer.$el.find(".drawer-body").animate({
        right: 0
      });
    });
  },
  close() {
    $("body").removeClass("no-scroll");
    cartDrawer.$el.find(".drawer-body").animate(
      {
        right: "-100%"
      },
      300,
      () => {
        cartDrawer.$el.fadeOut(300);
      }
    );
  },
  update: debounce(() => {
    const data = $(cartDrawer.$form).serializeArray();
    const updates = data.map((item) => item.value);
    fetch(
      // @ts-ignore
      window.Shopify.routes.root + "cart/update.js?sections=main-cart-drawer",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      }
    ).then((response) => response.json()).then((data2) => {
      const $section = $(data2.sections["main-cart-drawer"]);
      cartDrawer.$form.find(".drawer-content").replaceWith($section.find(".drawer-content"));
      cartDrawer.$form.find(".drawer-footer").replaceWith($section.find(".drawer-footer"));
    });
  }, 300),
  remove: (key) => {
    fetch(
      // @ts-ignore
      window.Shopify.routes.root + "cart/change.js?sections=main-cart-drawer",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      }
    ).then((response) => response.json()).then((data) => {
      const $section = $(data.sections["main-cart-drawer"]);
      cartDrawer.$form.find(".drawer-content").replaceWith($section.find(".drawer-content"));
      cartDrawer.$form.find(".drawer-footer").replaceWith($section.find(".drawer-footer"));
    });
  },
  updateCart() {
    this.$el.find(".drawer-loading").show();
    this.$el.find(".drawer-content").hide();
    this.$el.find(".drawer-footer").hide();
    fetch(
      // @ts-ignore
      window.Shopify.routes.root + "cart?sections=main-cart-drawer",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    ).then((response) => response.json()).then((data) => {
      const $section = $(data["main-cart-drawer"]);
      cartDrawer.$form.find(".drawer-content").replaceWith($section.find(".drawer-content"));
      cartDrawer.$form.find(".drawer-footer").replaceWith($section.find(".drawer-footer"));
      this.$el.find(".drawer-loading").hide();
      this.$el.find(".drawer-content").fadeIn(300);
      this.$el.find(".drawer-footer").fadeIn(300);
    });
  }
};
$("#CartDrawer-Form").on("click", ".qty-minus, .qty-plus", function() {
  const $input = $(this).siblings(".qty-input");
  if ($(this).hasClass("qty-minus")) {
    if ($input.val() > 1) {
      $input.val(+$input.val() - 1);
    }
  } else {
    $input.val(+$input.val() + 1);
  }
  cartDrawer.update();
});
$("#CartDrawer-Form").on("click", ".remove", function() {
  const key = $(this).data("key");
  cartDrawer.remove(key);
});
cartDrawer.$el.on("click", "[data-drawer-close]", function(e) {
  e.preventDefault();
  cartDrawer.close();
});
$("[data-cart-drawer-open]").on("click", function(e) {
  e.preventDefault();
  cartDrawer.open();
});
window.cartDrawer = cartDrawer;
document.querySelectorAll(".product-description-tab .product-nav-tabs a[href]").forEach((el) => {
  el.addEventListener("click", (e) => {
    e.preventDefault();
    const target = el.getAttribute("href");
    const $target = document.querySelector(target);
    const top = (($target == null ? void 0 : $target.offsetTop) || 0) - 40;
    window.scrollTo(0, top);
  });
});
